
























import { Vue, Component, Prop } from 'vue-property-decorator';
import posed from 'vue-pose';

import { baseAnimations } from '@/views/Onboarding/helpers';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Container: posed.div(baseAnimations()),
    Typography
  }
})
export default class YourStoreIlustra extends Vue {}
